import { env } from '../lib/env';

export function getImageUrl(imageId?: string | null) {
  if (!imageId) return '/fallback.svg';

  return `${env.VITE_IMAGE_URL}/${imageId}/public`;
}
